import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { t } from 'translation'

import SettingsPlaylistSongItem from './SettingsPlaylistSongItem'

import { removeFromPlaylist, reorderPlaylist } from 'store/actions'

const SettingsPlaylistSelectedList = ({
  playlist,
  allSongsMap,
  removeFromPlaylist,
  reorderPlaylist,
}) => {
  const selectedSongsInfo = playlist
    .filter((selectedSongId) => allSongsMap[selectedSongId])
    .map((selectedSongId) => allSongsMap[selectedSongId])

  const onDragEnd = ({ source, destination }) => {
    // dropped outside the list
    if (!destination) return
    reorderPlaylist(source.index, destination.index)
  }

  // Note: component reused from alarm submenu, so many of the same classes prefixed with 'alarm_...' are reused
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <ul
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={`alarm_block_list save_files_mod ${
              snapshot.isDraggingOver ? 'dragging_mod' : ''
            }`}
          >
            {!playlist.length && (
              <li className="alarm_block_list_item">
                <div className="alarm_block preview_mod song_btn_mod playlist_no_files_mod">
                  <div className="alarm_block_descr">
                    <div className="playlist_no_files_selected">
                      {t('playlist.YOU_DID_NOT_SELECT')}
                    </div>
                  </div>
                </div>
              </li>
            )}
            {selectedSongsInfo.map((song, i) => (
              <Draggable key={song.songId} draggableId={String(song.songId)} index={i}>
                {(provided, snapshot) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={provided.draggableProps.style}
                    className="alarm_block_list_item"
                  >
                    <SettingsPlaylistSongItem
                      {...song}
                      removeSongHandler={() => removeFromPlaylist(song.songId)}
                      selected={snapshot.isDragging}
                      selectable={false}
                      draggable={!snapshot.isDragging}
                    />
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  )
}

const mapStateToProps = ({ player: { allSongsMap, playlist } }) => ({
  allSongsMap,
  playlist,
})

const willMapDispatchToProps = {
  removeFromPlaylist,
  reorderPlaylist,
}

export default connect(
  mapStateToProps,
  willMapDispatchToProps
)(SettingsPlaylistSelectedList)

SettingsPlaylistSelectedList.propTypes = {
  removeFromPlaylist: PropTypes.func.isRequired,
  reorderPlaylist: PropTypes.func.isRequired,
  allSongsMap: PropTypes.object.isRequired,
  playlist: PropTypes.array.isRequired,
}
